<template>
    <ayuda-tema-base
        :busqueda="busqueda"
        :color="color"
        :faqs="faqs"
    />
</template>

<script>
import AyudaTemaBase from './AyudaTemaBase.vue';

export default {
    name: 'AyudaTemaCuenta',
    components: {
        AyudaTemaBase
    },
    props: {
        busqueda: {
            type: String,
            default: ''
        },
        color: {
            type: String,
            default: '#EF6C00'
        }
    },
    data() {
        return {
            faqs: [
                {
                    id: 1,
                    pregunta: '¿Cómo cierro sesión de forma segura?',
                    respuesta: `
                        <p>Usa la opción <strong>Cerrar sesión</strong> del menú lateral.</p>
                        <p>Esto invalida tu sesión y vuelve a la pantalla de login.</p>
                    `,
                    respuestaTexto: 'Usa la opción Cerrar sesión del menú lateral. Esto invalida tu sesión y vuelve a la pantalla de login.'
                },
                {
                    id: 2,
                    pregunta: '¿Qué hago si olvidé mis credenciales?',
                    respuesta: `
                        <p>Contacta con administración para restablecer acceso.</p>
                        <p>Indica agencia, email y teléfono de contacto.</p>
                    `,
                    respuestaTexto: 'Contacta con administración para restablecer acceso. Indica agencia, email y teléfono de contacto.'
                },
                {
                    id: 3,
                    pregunta: '¿Dónde puedo revisar o actualizar los datos de mi agencia?',
                    respuesta: `
                        <p>Desde el módulo de perfil de agencia puedes revisar:</p>
                        <ul>
                            <li>Información principal</li>
                            <li>Logo</li>
                            <li>Otros datos asociados a tu cuenta</li>
                        </ul>
                    `,
                    respuestaTexto: 'Desde el módulo de perfil de agencia puedes revisar la información principal, el logo y otros datos asociados a tu cuenta.'
                },
                {
                    id: 4,
                    pregunta: '¿Por qué mi sesión puede cerrarse automáticamente?',
                    respuesta: `
                        <p>Por seguridad, la sesión puede expirar tras un tiempo de inactividad o si el token deja de ser válido.</p>
                        <p>En ese caso tendrás que iniciar sesión de nuevo.</p>
                    `,
                    respuestaTexto: 'Por seguridad, la sesión puede expirar tras un tiempo de inactividad o si el token deja de ser válido. En ese caso tendrás que iniciar sesión de nuevo.'
                },
                {
                    id: 5,
                    pregunta: '¿A quién contacto si detecto un problema técnico?',
                    respuesta: `
                        <p>Puedes escribir a <strong>sistemas@rutasmeigas.com</strong>.</p>
                        <p>Indica agencia, reserva afectada si aplica y una descripción breve del problema.</p>
                    `,
                    respuestaTexto: 'Puedes escribir a sistemas@rutasmeigas.com. Indica agencia, reserva afectada si aplica y una descripción breve del problema.'
                }
            ]
        };
    }
};
</script>
